import React from 'react'
import { OutlinedInput, InputAdornment } from '@mui/material'
import { withStyles } from '@mui/styles'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const StyledOutlinedInput = withStyles(theme => ({
    root: {
        color: theme.palette.primary.main,
        width: 75,
        maxHeight: '35px',
        fontWeight: 500,
        background: 'white',
        marginRight: '10px',
        overflow: 'visible'
    },
    input : {
        transform: 'translateX(-4px)'
    },
    notchedOutline: {
        borderColor: '#EAEAEA !important'
    }
}))(OutlinedInput);

export default function InputPopup(props)
{
    const {text, open, setText, handleClick, handleBlur}  = props;
    // const regexp = /^[0-9\b]+$/;
    const regexp = /^\d*\.?\d{0,9}$/;
    return <StyledOutlinedInput value={text} onChange={e => { if(e.target.value === '' || regexp.test(e.target.value)) setText(e.target.value);}} onBlur={() => handleBlur()} onKeyDown={(ev) => {
        ev.stopPropagation();
        if (ev.key === 'Enter' || ev.key === 'Escape') 
            ev.target.blur();
      }}
    endAdornment={<InputAdornment onClick={e => handleClick(e)} style={{width: '5px', cursor: 'pointer', transform: 'translateX(-15px)'}} position="end" disableTypography><ArrowDropDownIcon style={{userSelect: 'none', fontSize:'2em',color: '#5A5A5A', transform: open ? 'rotate(180deg)' : 'none'}}/></InputAdornment>}/>
}



